import Rete from "rete";
import { NumberSocket,NumberControl } from "../rete-controls/NumberControl.js"
import ReteComponentStore from "../ReteComponentStore.js"

export default class NumberInputComponent extends Rete.Component {
    constructor(){
        super("Number Input"); // name
        this._categories = ["Input Nodes", "tryMe"];
    }

    builder(node) {
        let out1 = new Rete.Output('out1','OUT',NumberSocket);
        let numControl = new NumberControl(this.editor,"num",false);
      
        return node
        .addOutput(out1)
        .addControl(numControl);
    }

    worker(node, inputs, outputs) {
        outputs['out1'] = +node.data.num;
        //console.log(this.name + " node.data=" + JSON.stringify(node.data));
        //console.log(this.name + " outputs=" + JSON.stringify(outputs));
    }
}
//ReteComponentStore.add(new NumberInputComponent());